import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';
import styles from './checkbox.scss';
import PropTypes from 'prop-types';

export default function CheckboxIcon({ checked, ...rest }) {
	return (
		<IconBase type="checkbox" {...rest}>
			{checked ? (
				<path
					className={styles.checked}
					d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
				/>
			) : (
				<path
					className={styles.unChecked}
					d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
				/>
			)}
		</IconBase>
	);
}

CheckboxIcon.propTypes = {
	checked: PropTypes.bool,
	...iconPropTypes
};
